import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { useStyles } from './styles';

const Props = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    numberBox: PropTypes.string,
  }),
};

const DefaultProps = {
  classes: {
    root: '',
    numberBox: '',
  },
};

export default function Steps({ classes: customClasses }) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, customClasses.root)}>
      <div className={classes.item}>
        <Typography className={clsx(classes.numberBox, customClasses.numberBox)} variant="h5">
          01
        </Typography>

        <Typography>
          <b>Login or create a brand new account at Mind the Graph.</b>
        </Typography>
      </div>

      <KeyboardArrowDown className={classes.icon} />

      <div className={classes.item}>
        <Typography className={clsx(classes.numberBox, customClasses.numberBox)} variant="h5">
          02
        </Typography>

        <Typography>
          <b>
            Send a free trial invitation. The more friends you connect the more rewards you'll get.
          </b>
        </Typography>
      </div>

      <KeyboardArrowDown className={classes.icon} />

      <div className={classes.item}>
        <Typography className={clsx(classes.numberBox, customClasses.numberBox)} variant="h5">
          03
        </Typography>

        <Typography>
          <b>
            Enjoy your rewards, including up to a 100% discount or 7 days experiencing all benefits
            of a Researcher Subscription.
          </b>
        </Typography>
      </div>
    </div>
  );
}

Steps.propTypes = Props;
Steps.defaultProps = DefaultProps;
